import { render, staticRenderFns } from "./OrderTypeEdit.vue?vue&type=template&id=499db140&scoped=true"
import script from "./OrderTypeEdit.vue?vue&type=script&lang=js"
export * from "./OrderTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderTypeEdit.vue?vue&type=style&index=0&id=499db140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499db140",
  null
  
)

export default component.exports